export enum COST_DOCUMENT_TYPES {
  VatMargin = 1,
  Other = 2,
  Undefined = 3,
  Commercial = 4,
}
